import { render, staticRenderFns } from "./ResendEmail.vue?vue&type=template&id=495d0cd8&"
import script from "./ResendEmail.vue?vue&type=script&lang=js&"
export * from "./ResendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ResendEmail.vue"
export default component.exports